import React, { useState, useRef } from 'react';

function ComplianceForm({ onAddReport }) {
  const [formData, setFormData] = useState({
    state: '',
    documentType: '',
    file: null
  });

  const [showSubmitModal, setShowSubmitModal] = useState(false);
  const [showClearModal, setShowClearModal] = useState(false);
  const fileInputRef = useRef(null);

  const STATES = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware",
    "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",
    "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri",
    "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York",
    "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
    "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington",
    "West Virginia", "Wisconsin", "Wyoming"
  ];

  const DOCUMENT_TYPES = [
    "Amendments", "Bill of Sale", "Enterprise service agreement", "Franchise Agreement", "Employment Agreement",
    "Employee invention assignment and confidentiality agreement (EIACA)", "Inbound agreement", "Indemnity agreement",
    "Independent contractor agreement", "Influencer agreement", "Photography release", "Master service agreement",
    "Non-disclosure agreement (NDA)", "Non-compete agreement", "Order form", "Partnership agreement",
    "Property or equipment lease", "Purchase order", "Renewal order form", "Request for proposal (RFP)",
    "Security agreement", "Statement of work (SOW)", "Security and privacy addendum", "Termination notice",
    "Terms of use", "Transfer agreement", "Vendor service agreement", "Warranty", "Beta agreement",
    "Memorandum of understanding (MOU)", "License agreement", "Unilateral contract", "Cost- plus contract",
    "Fixed price contract", "Implied contract", "Express contract", "Unconscionable contract", "Unit price contract",
    "Adhesion contract", "Simple contract", "Bi-lateral contract", "Time and material contract", "Sales contract",
    "Aleatory contract", "Lease contract"
  ];

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'file') {
      const file = files[0];
      if (file && file.type !== 'application/pdf') {
        alert("Only PDF files are allowed!");
        return;
      }
      setFormData({ ...formData, file });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowSubmitModal(true);
  };

  const confirmSubmit = () => {
  const keywords = [
  "agreement", "terms", "confidential", "privacy", "liability", "compliance", "security",
  "non-disclosure", "contract", "obligation", "consent", "data", "access", "termination",
  "breach", "authorization", "responsibility", "conflict", "policy", "audit", "governance",
  "regulation", "federal", "state", "jurisdiction", "warranty", "disclaimer", "enforceable",
  "third party", "indemnify", "dispute", "settlement", "applicable", "effective date",
  "expiration", "revocation", "provision", "clause", "agreement date", "legal entity",
  "intellectual property", "GDPR", "CCPA", "HIPAA", "FERPA", "FCRA", "PCI", "SOX",
  "cybersecurity", "encryption", "controls", "safeguards", "monitoring", "risk",
  "incident", "reporting", "retention", "archiving", "employee", "contractor", "vendor",
  "service level", "subcontractor", "ownership", "usage", "limitation", "license",
  "compliant", "noncompliant", "confidentiality", "termination notice", "assignability",
  "binding", "governing law", "severability", "notice", "waiver", "entire agreement",
  "force majeure", "headings", "arbitration", "injunction", "damages", "refund", "penalty",
  "fine", "approval", "certification", "compliance officer", "training", "code of conduct",
  "investigation", "whistleblower", "notification", "inspection", "subpoena", "retention policy"
];
    const found = keywords.filter(k => formData.file?.name.toLowerCase().includes(k));
    const missing = keywords.filter(k => !found.includes(k));
    const score = Math.round((found.length / keywords.length) * 100);

    onAddReport({
      state: formData.state,
      documentType: formData.documentType,
      fileName: formData.file?.name,
      foundKeywords: found,
      missingKeywords: missing,
      complianceScore: score
    });

    setFormData({ state: '', documentType: '', file: null });
    fileInputRef.current.value = null;
    setShowSubmitModal(false);
  };

  const handleClear = () => {
    setShowClearModal(true);
  };

  const confirmClear = () => {
    setFormData({ state: '', documentType: '', file: null });
    fileInputRef.current.value = null;
    setShowClearModal(false);
  };

  return (
    <div id='tours' style={styles.container}>
      <h2 style={styles.heading}>Upload Compliance Document</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.field}>
          <label style={styles.label}>State:</label>
          <select name="state" value={formData.state} onChange={handleChange} required style={styles.select}>
            <option value="">-- Select State --</option>
            {STATES.map(state => <option key={state} value={state}>{state}</option>)}
          </select>
        </div>
        <div style={styles.field}>
          <label style={styles.label}>Document Type:</label>
          <select name="documentType" value={formData.documentType} onChange={handleChange} required style={styles.select}>
            <option value="">-- Select Document Type --</option>
            {DOCUMENT_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
          </select>
        </div>
        <div style={styles.field}>
          <label style={styles.label}>Upload PDF:</label>
          <input
            type="file"
            name="file"
            accept=".pdf"
            onChange={handleChange}
            required
            ref={fileInputRef}
            style={styles.fileInput}
          />
          <button type="button" onClick={handleClear} style={styles.clearButton}>Clear Form</button>
        </div>
        <button type="submit" style={styles.submitButton}>Submit</button>
      </form>

      {/* Submit Confirmation Modal */}
      {showSubmitModal && (
        <ConfirmModal
          message="Are you sure you want to submit the form?"
          onConfirm={confirmSubmit}
          onCancel={() => setShowSubmitModal(false)}
        />
      )}

      {/* Clear Confirmation Modal */}
      {showClearModal && (
        <ConfirmModal
          message="Are you sure you want to clear the form?"
          onConfirm={confirmClear}
          onCancel={() => setShowClearModal(false)}
        />
      )}
    </div>
  );
}

// Reusable confirmation modal component
function ConfirmModal({ message, onConfirm, onCancel }) {
  return (
    <div style={modalStyles.backdrop}>
      <div style={modalStyles.modal}>
        <p style={modalStyles.message}>{message}</p>
        <div style={modalStyles.buttons}>
          <button onClick={onConfirm} style={modalStyles.confirmBtn}>Yes</button>
          <button onClick={onCancel} style={modalStyles.cancelBtn}>No</button>
        </div>
      </div>
    </div>
  );
}

// Form styles
const styles = {
  container: {
    padding: '20px',
    maxWidth: '600px',
    margin: '0 auto'
  },
  heading: {
    textAlign: 'center',
    marginBottom: '20px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  field: {
    display: 'flex',
    flexDirection: 'column'
  },
  label: {
    marginBottom: '5px',
    fontWeight: 'bold'
  },
  select: {
    padding: '10px',
    fontSize: '16px'
  },
  fileInput: {
    marginBottom: '10px'
  },
  clearButton: {
    backgroundColor: '#f44336',
    color: 'white',
    padding: '8px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer'
  },
  submitButton: {
    backgroundColor: '#4CAF50',
    color: 'white',
    padding: '12px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '16px'
  }
};

// Modal styles
const modalStyles = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },
  modal: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '10px',
    minWidth: '300px',
    animation: 'fadeIn 0.3s ease-in-out',
    textAlign: 'center',
    boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
  },
  message: {
    marginBottom: '20px',
    fontSize: '18px'
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  confirmBtn: {
    backgroundColor: '#4CAF50',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer'
  },
  cancelBtn: {
    backgroundColor: '#f44336',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer'
  }
};

export default ComplianceForm;